import { memo, useEffect, useMemo } from "react";
import { NodeProps } from "reactflow";
import { Select } from "antd";

import styles from "./index.less";

import NodeCard from "../NodeCard";
import {
  FlowModuleItemType,
  ModuleInputKeyEnum,
} from "@packages/flow-core/module";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import { RenderInputProps } from "../render/RenderInput/types";
import Divider from "../Divider";
import { useFlow } from "../FlowEdit/useFlow";
import TextInput from "../render/RenderInput/templates/TextInput";

const MessageCuttingCondition = ({
  moduleId,
  inputs,
  item,
}: RenderInputProps) => {
  const cuttingType = item.value as string;
  const { updateNodeValue, updateModuleInput } = useFlow();

  const messageCuttingSeparatorInput = useMemo(() => {
    return inputs!.find(
      (item) => item.key === ModuleInputKeyEnum.messageCuttingSeparator
    )!;
  }, [inputs]);

  useEffect(() => {
    // 自定义
    if (cuttingType === "2") {
      updateModuleInput(moduleId, messageCuttingSeparatorInput.key, {
        ...messageCuttingSeparatorInput,
        type: "input",
        required: true,
      });
    } else {
      updateModuleInput(moduleId, messageCuttingSeparatorInput.key, {
        ...messageCuttingSeparatorInput,
        value: "",
        type: "hidden",
        required: false,
      });
    }
  }, [cuttingType]);

  return (
    <>
      <Select
        options={item.list}
        defaultValue={cuttingType}
        onChange={(v) => {
          updateNodeValue(moduleId, item.key, v);
        }}
        style={{ width: "100%" }}
      />
    </>
  );
};

/**
 * Node Message Output
 */
export default memo(function ({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { moduleId, inputs, outputs } = data;
  const { splitToolInputs } = useFlow();
  const { commonInputs } = splitToolInputs(inputs, moduleId);

  return (
    <NodeCard selected={selected} {...data}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          moduleId={moduleId}
          flowInputList={commonInputs}
          CustomComponent={{
            [ModuleInputKeyEnum.messageCuttingType]: MessageCuttingCondition,
            [ModuleInputKeyEnum.messageCuttingSeparator]: TextInput,
          }}
        />
      </div>
      <Divider text="输出" />
      <div className={styles.content}>
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
    </NodeCard>
  );
});
